import { Middleware } from '@nuxt/types'
import { Context } from '@nuxt/types/app'
import { getModule } from 'vuex-module-decorators'
import LoginModule from '~/store/LoginModule'

const loginStore: LoginModule = getModule(LoginModule)

function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return typeof payload.exp !== 'number' || payload.exp * 1000 < Date.now()
  } catch {
    return true
  }
}

const auth: Middleware = (context: Context) => {
  if (context.route.name?.startsWith('auth')) {
    return
  }

  const tokens = localStorage.getItem('token')
  if (tokens && isTokenExpired(tokens)) {
    loginStore.removeToken()
  }
  const isLoggedIn = !!localStorage.getItem('token')

  if (context.route.params) {
    const token = context.route.query.Token
    if (token !== undefined) {
      loginStore.removeToken()
      loginStore.setToken(token.toString())
      return
    }

    if (context.route.path === '/') {
      return context.redirect('/index')
    }
  }

  if (isLoggedIn) {
    return
  }

  return context.redirect({
    name: 'auth-login',
  })
}

export default auth
